import React from 'react'
import { Badge } from '../../../../components'
import * as colors from '../../../../assets/js/colors'
import { NFSE_STATUS } from '../../../../constants/fiscal'

// Só faz sentido para nota de cliente no município do Operador Logístico (frete municipal)
export default function BadgeNfseNota({ entrega }) {
  const municipal = Boolean(entrega.tp_city_id) && entrega.client_city_id === entrega.tp_city_id
  if (entrega.nfse_status === NFSE_STATUS.AUTORIZADO)
    return (
      <span title={entrega.nfse_numero ? `NFS-e nº ${entrega.nfse_numero}` : undefined}>
        <Badge color={colors.verde}>Emitida</Badge>
      </span>
    )
  if (entrega.nfse_status === NFSE_STATUS.PROCESSANDO)
    return <Badge color={colors.laranja}>Processando Emissão</Badge>
  if (!municipal) return '—'
  return <Badge color={colors.vermelho}>Não Emitida</Badge>
}
